var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebflow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1739_14708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 32.4035C22.9541 32.4035 31.4287 23.9289 31.4287 13.475C31.4287 3.021 22.9541 -5.45361 12.5001 -5.45361C2.04614 -5.45361 -6.42847 3.021 -6.42847 13.475C-6.42847 23.9289 2.04614 32.4035 12.5001 32.4035Z",
    fill: "#4353FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1719 11.9907L15.0391 15.561C15.0391 15.2876 14.2578 9.36572 14.2578 9.36572C12.4609 9.36572 11.5078 10.6392 11.0078 11.9907L9.625 15.5688C9.625 15.311 9.42969 12.022 9.42969 12.022C9.36299 11.31 9.03748 10.6471 8.51483 10.159C7.99217 9.67093 7.30866 9.39145 6.59375 9.37353L8.0625 18.3423C9.9375 18.3423 10.9531 17.0688 11.4766 15.7173L12.6484 12.6704C12.6484 12.7954 13.4297 18.3423 13.4297 18.3423C14.1964 18.3413 14.9429 18.0962 15.5609 17.6425C16.179 17.1888 16.6365 16.55 16.8672 15.8188L19.5234 9.36572C17.6484 9.36572 16.6641 10.6392 16.1641 11.9907H16.1719Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1739_14708"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.975098,
    width: 25,
    height: 25,
    rx: 7,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebflow);
export default __webpack_public_path__ + "static/media/Webflow.0d0ae7796740c7c84b8fa874783e8f7b.svg";
export { ForwardRef as ReactComponent };